import { render } from "./PasstypeRestrictionDates.vue?vue&type=template&id=63c45060"
import script from "./PasstypeRestrictionDates.vue?vue&type=script&lang=js"
export * from "./PasstypeRestrictionDates.vue?vue&type=script&lang=js"
script.render = render

export default script